// 下拉框本地字典
const DICT: any = {
  state: [
    {
      key: 1,
      value: '有效'
    },
    {
      key: 0,
      value: '无效'
    }
  ],
  state2: [
    {
      key: -1,
      value: '全部'
    },
    {
      key: 1,
      value: '启用'
    },
    {
      key: 0,
      value: '禁用'
    }
  ],
  orderState: [
    {
      key: -1,
      value: '全部'
    },
    {
      key: 1,
      value: '待支付'
    },
    {
      key: 2,
      value: '已支付'
    },
    {
      key: 3,
      value: '交易关闭'
    },
    // {
    //   key: 4,
    //   value: '已退款'
    // },
    {
      key: 5,
      value: '已发起支付'
    }
  ],
  settlementState: [
    {
      key: -1,
      value: '全部'
    },
    {
      key: 0,
      value: '待结算'
    },
    {
      key: 1,
      value: '结算中'
    },
    {
      key: 2,
      value: '已结算'
    }
  ],
  applicantType: [
    {
      key: -1,
      value: '全部'
    },
    {
      key: 0,
      value: '待入场'
    },
    {
      key: 1,
      value: '已入场'
    },
    {
      key: 2,
      value: '未入场'
    }
  ]
}

export default class comm {
  static dict (val: any) {
    return val ? DICT[val] : []
  }
}
